import { render, staticRenderFns } from "./History.vue?vue&type=template&id=5ea8f400"
import script from "./History.js?vue&type=script&lang=js&external"
export * from "./History.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports